import { render, staticRenderFns } from "./TaraFloatingAssistant.vue?vue&type=template&id=352533ba&scoped=true"
import script from "./TaraFloatingAssistant.vue?vue&type=script&lang=js"
export * from "./TaraFloatingAssistant.vue?vue&type=script&lang=js"
import style0 from "./TaraFloatingAssistant.vue?vue&type=style&index=0&id=352533ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352533ba",
  null
  
)

export default component.exports